import { render, staticRenderFns } from "./combinDetail.vue?vue&type=template&id=5585a18c&scoped=true&"
import script from "./combinDetail.vue?vue&type=script&lang=js&"
export * from "./combinDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5585a18c",
  null
  
)

export default component.exports